<template>
  <section id="step5" class="p-content-plan-manual-step">
    <div class="l-container">
      <h2 class="c-title--x-large">
        STEP5 本文を執筆する
      </h2>
      <div class="l-rows">
        <p>
          STEP4で設計した見出しを軸に、ユーザーの検索意図を満たせるような内容の本文を執筆してください。<br />
          <strong
            >文字数を増やそうと不必要な情報を含めたり、クローラーからの評価を高める目的で対策キーワードや関連キーワードを必要以上に文章内に詰め込めたりすると逆効果となり、ユーザーにとっては分かりにくい・ニーズを満たせない内容となってしまう可能性があります。</strong
          ><br />
          対策キーワード・関連キーワードについては、ユーザーの検索意図を満たすためにあくまで自然に配置することを心がけましょう。
        </p>
      </div>
      <section
        class="p-content-plan-manual-content-words l-section"
        ref="contentWords"
      >
        <h3 class="c-title--medium" ref="contentWordsTitle">
          コンテンツの文字量
        </h3>
      </section>
      <section
        class="p-content-plan-manual-trend-words l-section"
        ref="trendWords"
      >
        <h3 class="c-title--medium" ref="trendWordsTitle">
          上位ページのコンテンツに含まれる「単語」の傾向
        </h3>
      </section>
    </div>
  </section>
</template>
<script>
export default {
  mounted() {
    this.appendContentWords();
    this.appendTrendWords();
  },
  methods: {
    appendContentWords() {
      // 見出しの個数のDOMを挿入する
      if (this.$refs.contentWords && this.$refs.contentWordsTitle) {
        const block = document
          .querySelector('[data-include-manual-download="contentWords"]')
          .cloneNode(true);

        const h3 = block.querySelector('.l-block__header');
        h3.parentNode.replaceChild(this.$refs.contentWordsTitle, h3);

        this.$refs.contentWords.appendChild(block);
      }
    },
    appendTrendWords() {
      // 見出しの個数のDOMを挿入する
      if (this.$refs.trendWords && this.$refs.trendWordsTitle) {
        const block = document
          .querySelector('[data-include-manual-download="trendWords"]')
          .cloneNode(true);

        const h3 = block.querySelector('.l-block__header');
        h3.parentNode.replaceChild(this.$refs.trendWordsTitle, h3);

        this.$refs.trendWords.appendChild(block);
      }
    }
  }
};
</script>
